export const FETCH_STANDARDS_REQUEST = 'FETCH_STANDARDS';
export const FETCH_STANDARDS_SUCCESS = 'FETCH_STANDARDS_SUCCESS';
export const FETCH_STANDARDS_FAILURE = 'FETCH_STANDARDS_FAILURE';
export const RESET_FETCH_STANDARDS_ERRORS = 'RESET_FETCH_STANDARDS_ERRORS';
